module.exports = __webpack_public_path__ + "img/newspapers_button_last_up.d1a4267c.png";